import { Grid, InputAdornment, Typography } from "@mui/material";

import { AdornmentButton } from "components/GeneralStyled";
import PriceInput from "components/PriceInput";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";

function RepayAmount({ selectedCoin, repayAmountMax, loading }) {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  const amount = watch("amount");

  const calcMax = useMemo(() => {
    const available = repayAmountMax?.availableBalance;
    const maximum = repayAmountMax?.maximumRepaymentAmount;

    if (available <= maximum) return available;
    else return maximum;
  }, [
    repayAmountMax?.availableBalance,
    repayAmountMax?.maximumRepaymentAmount,
  ]);

  return (
    <Grid item xs={12}>
      <Typography variant="h6" color="text.main">
        Repay Amount
      </Typography>

      <PriceInput
        value={amount}
        onChange={(e) => setValue("amount", e)}
        placeholder="Amount"
        showPrefix={false}
        allowNegative={true}
        disabled={loading}
        maxDecimal={8}
        coinName={selectedCoin?.coinName}
        max={repayAmountMax?.maximumRepaymentAmount}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <AdornmentButton
                disabled={loading}
                variant="text"
                color="secondary"
                onClick={() => setValue("amount", calcMax)}
              >
                Max
              </AdornmentButton>
            </InputAdornment>
          ),
        }}
        error={!!errors?.amount}
        helperText={errors?.amount?.message}
      />
    </Grid>
  );
}

export default RepayAmount;
